import { createFileRoute } from '@tanstack/react-router'
import { PublicViewingConfirm } from '../components/viewings/PublicViewingConfirm'

// The applicant's viewing confirm page (spec 2026-10-25-12). Outside routes/$org
// like the resident page: the thread token in the path is the whole
// authorization, and only a viewing an application of this thread attends shows.
export const Route = createFileRoute('/c/$orgCode/$token_/viewings/$viewingUid')({
    component: PublicViewingRoute,
})

function PublicViewingRoute() {
    const { orgCode, token, viewingUid } = Route.useParams()
    return <PublicViewingConfirm orgCode={orgCode} token={token} viewingUid={viewingUid} />
}
